module.exports = __webpack_public_path__ + "img/slide11.1f632d29.png";